import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { getPublicRoutes, getProtectedRoutes } from './routeConfig.ts';
import ProtectedRoute from '../components/ProtectedRoute';
import DashboardLayout from '../components/DashboardLayout';
import RFPLayout from '../components/RFPLayout.tsx';
import BrandAdminLayout from '../components/BrandAdminLayout.tsx';

const TravelerMarketing = React.lazy(
  () => import('../pages/TravelerMarketing')
);
const RFPPage = React.lazy(() => import('../pages/RFPPage'));
const PPPExplainer = React.lazy(() => import('../pages/PPPExplainer'));
const BrandDashboard = React.lazy(
  () => import('../components/HotelBrands/BrandDashboard')
);
const BrandHotels = React.lazy(
  () => import('../components/HotelBrands/BrandHotels')
);
const BrandAdminReporting = React.lazy(
  () => import('../pages/BrandAdminReporting')
);
const EnterpriseHotels = React.lazy(
  () => import('../components/HotelBrands/EnterpriseHotels')
);
const BrandHotelDetail = React.lazy(
  () => import('../components/HotelBrands/HotelDetailView')
);
const PPPExplainerBrand = React.lazy(() => import('../pages/PPPExplainer'));

const AppRoutes: React.FC = () => {
  const publicRoutes = getPublicRoutes();
  const protectedRoutes = getProtectedRoutes();

  // Filter out TravelerMarketing and all brand-admin routes from dashboard routes
  const dashboardRoutes = protectedRoutes.filter(
    route =>
      route.path !== '/hotels/:id/travel-marketing' &&
      !route.path.startsWith('/brand-admin')
  );

  return (
    <Routes>
      {/* Public Routes (login, forgot password, etc.) */}
      {publicRoutes.map(({ path, name, component: Component, props }) => {
        if (
          name === 'rfp' ||
          name === 'rfp-our-approach' ||
          name === 'rfp-portal'
        ) {
          return null; // Skip these, they're handled below
        } else
          return (
            <Route key={path} path={path} element={<Component {...props} />} />
          );
      })}

      {/* RFP Routes with RFP Layout */}
      <Route path="/rfp/:rfpLinkId" element={<RFPLayout />}>
        <Route index element={<RFPPage />} />
        <Route path="our-approach" element={<PPPExplainer />} />
        <Route path="portal" element={<PPPExplainer />} />
      </Route>

      {/* Protected route without dashboard layout */}
      <Route
        path="/hotels/:id/travel-marketing"
        element={
          <ProtectedRoute>
            <TravelerMarketing />
          </ProtectedRoute>
        }
      />

      {/* Brand Admin Routes with nested layout */}
      {/* Brand Admin Routes with nested layout */}
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/brand-admin" element={<BrandAdminLayout />}>
          <Route path="brand-dashboard" element={<BrandDashboard />} />
          <Route path="brand-hotels" element={<BrandHotels />} />
          <Route path="brand-hotels/:brandName/:hotelId" element={<BrandHotelDetail />} />
          <Route path="reporting" element={<BrandAdminReporting />} />
          <Route path="brand-dashboard/:brandName/enterprise-hotels/:enterpriseId" element={<EnterpriseHotels />} />
          <Route path="brand-dashboard/:brandNameenterprise-hotels/:enterpriseId/:hotelId" element={<BrandHotelDetail />} />
          <Route path="ppp-explainer" element={<PPPExplainerBrand />} />
        </Route>
      </Route>

      {/* <Route
        path="/integrations/instructions"
        element={
          <ProtectedRoute>
            <IntegrationsAdmin />
          </ProtectedRoute>
        }
      /> */}

      {/* Protected routes with dashboard layout */}
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        {dashboardRoutes.map(({ path, component: Component, props }) => (
          <Route key={path} path={path} element={<Component {...props} />} />
        ))}
      </Route>
    </Routes>
  );
};

export default AppRoutes;
